<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" scrollable persistent max-width="500px">
            <v-card
                tile
                :loading="$apollo.queries.plant.loading ? 'white' : null"
            >
                <v-alert class="mb-0" v-if="error" tile type="error">{{
                    error
                }}</v-alert>
                <v-card-title
                    class="primary white--text"
                    v-if="$apollo.queries.plant.loading"
                    >Loading</v-card-title
                >
                <v-card-title class="primary white--text" v-else>{{
                    this.plant ? this.plant.name : ""
                }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4 pb-0">
                    <v-form ref="form">
                        <v-row>
                            <!-- Pot Sizes -->
                            <v-col cols="12">
                                <p
                                    class="mt-n2 mb-0 caption font-weight-medium"
                                >
                                    <v-avatar left>
                                        <v-icon>straighten</v-icon> </v-avatar
                                    >Pot Size*
                                </p>
                                <v-chip-group
                                    v-model="editedItem.selectedPlantPotSize"
                                    active-class="primary dark"
                                    mandatory
                                    column
                                >
                                    <v-chip
                                        v-for="item in plantPotSizes"
                                        :key="item.node.id"
                                        :value="item.node"
                                        :disabled="
                                            $apollo.queries.plant.loading
                                        "
                                        >{{
                                            item.node.potSize.potSizeCm
                                        }}cm</v-chip
                                    >
                                </v-chip-group>
                            </v-col>

                            <!-- Colors -->
                            <v-col cols="12">
                                <p
                                    class="mt-n2 mb-0 caption font-weight-medium"
                                >
                                    <v-avatar left>
                                        <v-icon>color_lens</v-icon> </v-avatar
                                    >Color*
                                </p>
                                <v-chip-group
                                    v-model="editedItem.selectedColor"
                                    active-class="primary dark"
                                    mandatory
                                    column
                                >
                                    <v-chip
                                        v-for="item in plantColors"
                                        :key="item.node.color.id"
                                        :value="item.node.color"
                                        :disabled="
                                            $apollo.queries.plant.loading
                                        "
                                        >{{ item.node.color.color }}</v-chip
                                    >
                                </v-chip-group>
                            </v-col>

                            <!-- Environments -->
                            <v-col cols="12">
                                <p
                                    class="mt-n2 mb-0 caption font-weight-medium"
                                >
                                    <v-avatar left>
                                        <v-icon>blur_on</v-icon> </v-avatar
                                    >Environment*
                                </p>
                                <v-chip-group
                                    v-model="editedItem.selectedEnvironment"
                                    active-class="primary dark"
                                    mandatory
                                    column
                                >
                                    <v-chip
                                        v-for="item in plantEnvironments"
                                        :key="item.node.environment.id"
                                        :value="item.node.environment"
                                        :disabled="
                                            $apollo.queries.plant.loading
                                        "
                                        >{{
                                            item.node.environment.environment
                                        }}</v-chip
                                    >
                                </v-chip-group>
                            </v-col>

                            <!-- Tags -->
                            <v-col cols="12">
                                <p
                                    class="mt-n2 mb-0 caption font-weight-medium"
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >turned_in_not</v-icon
                                        > </v-avatar
                                    >Tag
                                </p>
                                <v-chip-group
                                    v-model="editedItem.selectedTag"
                                    active-class="primary dark"
                                    column
                                >
                                    <v-chip
                                        v-for="item in plantTags"
                                        :key="item.node.tag.id"
                                        :value="item.node.tag"
                                        :disabled="
                                            $apollo.queries.plant.loading
                                        "
                                        >{{ item.node.tag.tag }}</v-chip
                                    >
                                </v-chip-group>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pb-5 pr-5">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="close">Cancel</v-btn>
                    <v-btn
                        outlined
                        rounded
                        :loading="isSaving"
                        :disabled="$apollo.queries.plant.loading"
                        color="primary"
                        @click="add"
                        >OK</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import gql from "graphql-tag";
export default {
    name: "plant-config-dialog",
    props: ["dialog", "plantNodeId"],

    apollo: {
        plant: {
            query: gql`
                query plant($id: ID!) {
                    plant(id: $id) {
                        id
                        name
                        defaultSupplier {
                            id
                            name
                        }
                        plantColorSet {
                            edges {
                                node {
                                    id
                                    color {
                                        id
                                        color
                                    }
                                }
                            }
                        }
                        plantPotSizeSet {
                            edges {
                                node {
                                    id
                                    potSize {
                                        id
                                        potSizeCm
                                    }
                                    youngPlantDefaultCost
                                    plantFixedCostTemplate {
                                        id
                                        failureRate
                                        totalCost
                                    }
                                }
                            }
                        }
                        plantEnvironmentSet {
                            edges {
                                node {
                                    id
                                    environment {
                                        id
                                        environment
                                    }
                                }
                            }
                        }
                        plantTagSet {
                            edges {
                                node {
                                    id
                                    tag {
                                        id
                                        tag
                                    }
                                }
                            }
                        }
                        plantGrowthTemplateSet {
                            edges {
                                node {
                                    id
                                    name
                                    numPhases
                                    maxSalesDays
                                    potSize {
                                        id
                                        potSizeCm
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    id: this.plantNodeId
                };
            },
            skip: true,
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.plant,
            pollInterval: 60000 // ms
        }
    },

    data: function() {
        return {
            error: null,
            isSaving: false,

            skipQuery: true,
            plant: {},

            editedItem: {
                selectedPlantPotSize: null,
                // selectedPotSize: null,
                selectedColor: null,
                selectedEnvironment: null,
                selectedTag: null
            },

            defaultEditedItem: {
                selectedPlantPotSize: null,
                // selectedPotSize: null,
                selectedColor: null,
                selectedEnvironment: null,
                selectedTag: null
            }
        };
    },
    computed: {
        plantPotSizes: function() {
            var _sorted =
                this.plant && this.plant.plantPotSizeSet
                    ? this.plant.plantPotSizeSet.edges
                    : [];

            if (_sorted.length > 0) {
                _sorted = _sorted.sort((a, b) => {
                    return a.node.potSize.potSizeCm - b.node.potSize.potSizeCm;
                });
            }

            // console.log(_sorted);

            return _sorted;
        },
        plantColors: function() {
            return this.plant && this.plant.plantColorSet
                ? this.plant.plantColorSet.edges
                : [];
        },
        plantEnvironments: function() {
            return this.plant && this.plant.plantEnvironmentSet
                ? this.plant.plantEnvironmentSet.edges
                : [];
        },
        plantTags: function() {
            return this.plant && this.plant.plantTagSet
                ? this.plant.plantTagSet.edges
                : [];
        }
    },
    watch: {
        // // reset form when dialog open or close
        // dialog(val) {
        //     if (val) {
        //         // reset form
        //         this.editedItem.selectedPotSize = this.plantPotSizes[0]
        //             ? this.plantPotSizes[0].node.potSize
        //             : null;
        //         this.editedItem.selectedColor = this.plantColors[0]
        //             ? this.plantColors[0].node.color
        //             : null;
        //         this.editedItem.selectedEnvironment = this.plantEnvironments[0]
        //             ? this.plantEnvironments[0].node.environment
        //             : null;
        //         this.editedItem.selectedTag = null;
        //     }
        // },
        plantNodeId(val) {
            if (val) {
                this.$apollo.queries.plant.skip = false;
                this.$apollo.queries.plant.refresh();
            }
        },
        plant(val) {
            if (val) {
                // reset form
                this.editedItem.selectedPlantPotSize = this.plantPotSizes[0]
                    ? this.plantPotSizes[0].node
                    : null;
                this.editedItem.selectedColor = this.plantColors[0]
                    ? this.plantColors[0].node.color
                    : null;
                this.editedItem.selectedEnvironment = this.plantEnvironments[0]
                    ? this.plantEnvironments[0].node.environment
                    : null;
                this.editedItem.selectedTag = null;
            }
        }
    },
    methods: {
        close() {
            this.$emit("update:dialog", false);
            this.$apollo.queries.plant.skip = true;
        },
        add() {
            this.$apollo.queries.plant.skip = true;
            // update parent object
            this.$emit("item-added", {
                plant: this.plant,
                plantPotSize: this.editedItem.selectedPlantPotSize,
                potSize: this.editedItem.selectedPlantPotSize.potSize,
                color: this.editedItem.selectedColor,
                environment: this.editedItem.selectedEnvironment,
                tag: this.editedItem.selectedTag
            });
        }
    }
};
</script>